import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("Municipio");
const crud = rpcCrudService<models.Municipio, models.Municipio>(controller);

export const DireccionMunicipio = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */

    query: async (): Promise<models.MunicipioDTO[]> => await controller('Query', {},),
    queryByEstado: async (IdEstado:number): Promise<models.MunicipioDTO[]> => await controller("queryByEstado",{ IdEstado }),
}, {
        queryByEstado: true,
        query: true,
        getMemo: true,
    }, {
        add: true,
        delete: true,
        update: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/DireccionMunicipio.tsx